module.exports = __webpack_public_path__ + "static/media/st.6f40144f.png";